import React from "react";
// TODO: Sanatize html string and add tests

/**
 * 
 * Render html string as HTML element with sanitization
 * 
 * @param {Object} props
 * @param {string} props.tag - tag name
 * @param {string} props.content - html string
 * @param {string} [props.className] - class name
 * 
 * @returns {JSX.Element}
 */
export function HtmlFromString(props) {
  const { tag, content, className } = props;

  if (!content?.trim() || !tag || typeof content !== "string") {
    return null;
  }

  return React.createElement(tag, {
    dangerouslySetInnerHTML: { __html: content },
    className,
  });
}

HtmlFromString.defaultProps = {
  tag: "div",
  className: "",
};
